export const PeriodDisplayTypes = {
  CONTRIBUTION: 'Offering Period',
  CURRENT: 'Current Period',
  PURCHASE: 'Purchase',
  PREVIOUS: 'Previous Period',
};
